module.exports = __webpack_public_path__ + "img/parameter.3c49a40c.png";